import type { SlotName } from '~/.server/chat/slots';
import type { SlotValue } from './wizardStep';

const PERIOD_LABELS: Record<string, string> = { monthly: 'mes', daily: 'día', hourly: 'hora' };
const TIMING_LABELS: Record<string, string> = { now: 'Ahora', lt_3mo: '< 3 meses', exploring: 'Explorando' };

/** Format an integer euro amount with Spanish thousands separators ("."), ICU-independent. */
function formatEuros(n: number): string {
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** Prettify a slug: hyphens → spaces, capitalise each word. */
export function prettifySlug(slug: string): string {
  return slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Human-readable Spanish label for a confirmed slot answer (user bubble text). */
export function answerLabel(
  slot: SlotName,
  value: SlotValue,
  categories: { value: string; label: string }[] = [],
): string {
  switch (slot) {
    case 'businessType': {
      const slug = String(value);
      const cat = categories.find((c) => c.value === slug);
      return cat ? cat.label : prettifySlug(slug);
    }
    case 'city':
    case 'neighborhood': {
      if (value && typeof value === 'object' && 'name' in value) {
        return String((value as { name: string }).name);
      }
      return prettifySlug(String(value));
    }
    case 'budgetAmount':
    case 'budgetPeriod': {
      if (value && typeof value === 'object' && 'budgetAmount' in value) {
        const b = value as { budgetAmount: number; budgetPeriod: string };
        return `${formatEuros(b.budgetAmount)} €/${PERIOD_LABELS[b.budgetPeriod] ?? 'mes'}`;
      }
      return String(value);
    }
    case 'headcount':
      return `${value} ${Number(value) === 1 ? 'persona' : 'personas'}`;
    case 'timing':
      return TIMING_LABELS[String(value)] ?? String(value);
    case 'contact': {
      if (value && typeof value === 'object' && 'email' in value) {
        const c = value as { name?: string; email: string };
        return c.name && c.name.trim() ? c.name : c.email;
      }
      return String(value);
    }
    default:
      return String(value);
  }
}
